module.exports = __webpack_public_path__ + "assets/person_white.2efa1e58.svg";